export default "__VITE_ASSET__CqMzUcFr__"